export const propertyAssignmentStatus = {
    New: 0,
    Editing: 1,
    Submitted: 2,
    Approved: 3,
    Reopened: 4
}